export default __webpack_public_path__ + "static/media/MDV_C__0001_Layer-5.4de62f11.png";